import React, {memo} from 'react';

import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import {setErrorBoundary} from '@/actions/appStateAction';
import {postUIErrorReport} from '@/api/deviceApi';
import ErrorBoundary from '@/components/errorBoundary/ErrorBoundary';
import {getErrorBoundary} from '@/selectors/appSelector';

import ErrorPage from './error/ErrorPage';

function ErrorBoundaryProvider({children}) {
  const dispatch = useDispatch();
  const errorBoundary = useSelector(getErrorBoundary);

  const onSetErrorBoundary = (...args) => dispatch(setErrorBoundary(...args));

  // eslint-disable-next-line no-unused-vars
  const onSendError = (error, errorInfo) => {
    // const uiError = {
    //   errorMessage: error.message,
    //   errorInfo: error.stack,
    //   componentStack: errorInfo.componentStack,
    // };
    // localStorage.setItem('applicationError', JSON.stringify(uiError));
    postUIErrorReport(error, errorInfo);
  };

  // const onClickRefresh = () => {
  //   window.location.reload(true);
  // };

  return (
    <ErrorBoundary
      content={<ErrorPage />}
      errorBoundary={errorBoundary}
      setErrorBoundary={onSetErrorBoundary}
      sendError={onSendError}
      // onClick={onClickRefresh}
    >
      {children}
    </ErrorBoundary>
  );
}

ErrorBoundaryProvider.propTypes = {
  children: PropTypes.node,
};

ErrorBoundaryProvider.defaultProps = {
  children: null,
};

export default memo(ErrorBoundaryProvider);
